import UtilCache from '../cache';
import urlConfig from './urlConfig';

// 驼峰转换下划线
function toLine (name) {
    return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

// 下划线转换驼峰
function toCamel (name) {
    return name.replace(/_(\w)/g, function (all, letter) {
        return letter.toUpperCase();
    });
}

function getSingleDict (dictName) {
    const nameChain = dictName.split('.');
    const realDictName = nameChain[nameChain.length - 1];
    const nameChainLine = toLine(dictName);
    const nameChainCamel = toCamel(dictName);
    // 先从localStorage中尝试获取想要的字典
    const tempResult =
        UtilCache.getCacheWithChain(dictName) ||
        UtilCache.getCacheWithChain(nameChainCamel) ||
        UtilCache.getCacheWithChain(nameChainLine);
    if (!!tempResult) {
        return new Promise((resolve) => {
            resolve({
                data: tempResult,
                name: realDictName,
            });
        });
    } else {
        // 如果不在localStorage里面,则去config里面搜索
        return new Promise((resolve, reject) => {
            let flag = true;
            for (let key in urlConfig) {
                // 必须是去掉config里面的之后 以.开头或者正好相等
                const keyCamel = toCamel(key);
                if (
                    nameChainCamel === keyCamel ||
                    (nameChainCamel.indexOf(keyCamel) >= 0 && nameChainCamel[keyCamel.length] === '.')
                ) {
                    flag = false;
                    urlConfig[key]()
                        .then((res) => {
                            UtilCache.setCacheWithChain(
                                key,
                                res?.data?.data?.data || res?.data?.data || res?.data || res
                            );
                            const tempResult =
                                UtilCache.getCacheWithChain(dictName) ||
                                UtilCache.getCacheWithChain(nameChainCamel) ||
                                UtilCache.getCacheWithChain(nameChainLine);
                            if (!tempResult) {
                                console.warn(`本地存储中没有${dictName}, 请检查本地存储`);
                                resolve([undefined, realDictName]);
                            }
                            resolve({
                                data: tempResult,
                                name: realDictName,
                            });
                        })
                        .catch(() => {
                            reject();
                        });
                }
            }
            if (flag) {
                console.warn(`无法在配置项中找到${dictName}, 请检查是否在urlConfig里面正确配置`);
                resolve([undefined, realDictName]);
            }
        });
    }
}

// 获取字典, 如果没有就根据urlConfig里面的去获取. 传入一个字典名字,字典链或者字典名数组.
// getDict('tools.financeDict');
// getDict(['tools.financeDict', 'tools.eventDict]);
// 返回格式, 对象, 字典链的最后一项
function getDict (dictNameList) {
    let result = {};
    if (typeof dictNameList === 'string') {
        return new Promise((resolve) => {
            getSingleDict(dictNameList).then((res) => {
                // console.log(res);
                resolve(res.data);
            });
        });
    } else {
        let taskList = [];
        dictNameList.forEach((dictName) => {
            taskList.push(
                getSingleDict(dictName).then((res) => {
                    if (res.data) {
                        result[res.name] = res.data;
                    }
                })
            );
        });
        return Promise.all(taskList);
    }
}

export default {
    getDict,
};
